import React, { useContext, useEffect, useRef, useState } from "react";
import * as S from "./ChatbotImgReaderCase.style"
import { ThemeContext } from 'styled-components';
import { useLazyQuery, useMutation } from "@apollo/client";
import { CONSULT_GENERAL_CHAT_IN_FLORENCE_CHATGPT, MUTATION_CHAT_BOX } from "../../../../../../graphql/mutations/Chat";
import useSize from "../../../../../../hooks/useSize";
import { useTranslation } from "react-i18next";
import useDoctorData from "../../../../../../hooks/useDoctorData";
import ZaialoadingPoints from "../../../../../zaiaComponents/zaiaLoadingPoints";
import ChatbotInput from "../../chatbotInput";
// import Message from "../../message";
import { useStateValue } from "../../../../../../contextAPI/StateProvider";
import useUploadTempDoc from "../../../../../../hooks/useUploadTempDoc";
import useUploadTempSeveralDocs from "../../../../../../hooks/useUploadTempSeveralDocs";
import useImageProcessorConfamaDematology from "../../../../../../hooks/useImageProcessorConfamaDematology";
import ZaiaReaction from "../../../../../zaiaComponents/zaiaReaction";
import Message from "../../../../algorithms/components/message";
import MessageType from "../../../components/messageType";

// pipes
import * as P from "../../../../../../utils/pipes";
import YesOrNo from "../../yesOrNo";
import ChatbotInitialSelector from "./components/chatbotInitialSelector";
import ChatbotMessagesDisplay from "./components/chatbotMessagesDisplay/ChatbotMessagesDisplay";
import PatientSelection from "./components/patientSelection/PatientSelection";
import useTextProcessorConfamaDematology from "../../../../../../hooks/useTextProcessorConfamaDematology";
// import ChatbotMessagesDisplay from "./components/chatbotMessagesDisplay";

const bgChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/chat-background.svg`
const monacoChatbot = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-logo.svg`
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ChatbotImgReaderCase() {

  const fileInput = useRef(null);
  const element = document.getElementById("chatbot-container");
  const { t, i18n: { language } }= useTranslation("global");
  const { doctorData } = useDoctorData();
  const [severalImgs, setSeveralImgs] = useState(false);
  const {tempDoc, dataDoc, errorFormat, uploadTempDoc, deleteDoc} = useUploadTempDoc();
  const {tempDocs, dataDocs, errorFormatDocs, uploadMultiDocs, deleteDocs, errorLimit} = useUploadTempSeveralDocs();
  const {uploadFileProcessor, data, loading, error, cleanAction} = useImageProcessorConfamaDematology();  
  const {textProcessor, dataTextProcessor, loadingTextProcessor, errorTextProcessor, cleanActionTextProcessor} = useTextProcessorConfamaDematology();  
  const [algorithm, setAlgorithm] = useState("dermatology_confama");
  const [messages, setMessages] = useState([]);
  const [patientVerified, setPatientVerified] = useState(false);
  const [firstMessage, setFirstMessage] = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [firstConsult, setFirstConsult] = useState(true);
  const [imageProcessContext, setImageProcessContext] = useState("")

  const currentThread = "thread-" + crypto.randomUUID();


  const [chatBox, {loading: chatLoading}] = useMutation(MUTATION_CHAT_BOX);

  const patientMessage = (msg, type, file) => {
    let allMessages = messages;
    allMessages.push(
      {
        id: Date.now(),
        message: msg,
        type: type,
        file: file
      }
    )
    setMessages([...allMessages])
  }


  const autoScroll = () => {
    if(element) element.scrollTop = element.scrollHeight - element.clientHeight;
  }

  const customBotMessage = async (msg, setSubmitting, resetForm, files) => {    
    try {
      if(resetForm) resetForm();
      if(setSubmitting) setSubmitting(false);

      let data 
      if(firstConsult) {
        
        data = await uploadFileProcessor(files, msg, algorithm);
        patientMessage(data.data.analysis, 'patient');
        setImageProcessContext(data.data.analysis);
        setFirstConsult(false);
        
      } else {
        console.log("eu no sei que fazer", patientData);
        
        data = await textProcessor(msg, imageProcessContext, patientData.document, doctorData.id, currentThread);
  
        console.log("Au Te amo", data);
        patientMessage(data.data.text, 'patient');
        setImageProcessContext("");
      }

      autoScroll()
    } catch (error) {
      console.log(error);
    }
  }

  const handleSubmitSeveralFiles = async (values, { setSubmitting, resetForm }) => {        
    
    tempDocs.forEach((doc, index) => {
      patientMessage(
        index === tempDocs.length - 1 ? values.msg : '',
        'doctor', 
        URL.createObjectURL(doc)
      );
    });
    customBotMessage(values.msg, setSubmitting, resetForm, [...tempDocs]);
    deleteDocs();
    autoScroll();

    setFirstMessage(true);
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {   
    // if(tempDoc) {
      console.log("tan", values.msg);
      patientMessage(values.msg, 'doctor');
      customBotMessage(values.msg, setSubmitting, resetForm);
      deleteDoc();
      autoScroll(); 
    // } else {
    //   patientMessage(values.msg, 'doctor');
    //   botMessage(values.msg, setSubmitting, resetForm);
    //   autoScroll();
    // }
    setFirstMessage(true);
  };

  // const botMessage = async (msg, setSubmitting, resetForm) => {    
  //   try {
  //     if(resetForm) resetForm();
  //     if(setSubmitting) setSubmitting(false);
  //     const {
  //       data: {
  //         chatBot,
  //       },
  //     } = await chatBox({
  //       variables: {
  //         message: msg,
  //         doctorId: doctorData?.id,
  //       },
  //     });
  //     if (!chatLoading) {
  //       setMessages(
  //         [...messages,
  //         {
  //           id: Date.now(),
  //           message: chatBot.message,
  //           payload: chatBot.payload,
  //           type: 'bot',
  //         }]
  //       )
  //       autoScroll()
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }


  return (
    <S.ChatbotImgReaderCase>
      <input
        type="file"
        ref={fileInput}
        onChange={(e) => 
          // algorithm === "prostate"
          // ? 
          uploadMultiDocs(e, 5)
          // : uploadTempDoc(e)
        }
        style={{display: 'none'}}
        accept="image/*,.dcom"  
        multiple  
      />
      <div className="content">
        {
          !patientData && <>
            <PatientSelection
              patientData={patientData}
              setPatientData={setPatientData}
            />
          </>
        }
        {
          patientData && <>
            {
              !firstMessage &&
              <ChatbotInitialSelector
                patientData={patientData}
                messages={messages}
                setMessages={setMessages}
                algorithm={algorithm}
                handleSubmitSeveralFiles={handleSubmitSeveralFiles}
                handleSubmit={handleSubmit}
                uploadMultiDocs={uploadMultiDocs}
                uploadTempDoc={uploadTempDoc}
                deleteDocs={deleteDocs}
                tempDocs={tempDocs}
                dataDoc={dataDoc}
                dataDocs={dataDocs}
                severalImgs={severalImgs}
                fileInput={fileInput}
                setPatientData={setPatientData}
              />
            }
            {
              firstMessage &&
              <ChatbotMessagesDisplay
                patientData={patientData}
                messages={messages}
                setMessages={setMessages}
                algorithm={algorithm}
                handleSubmitSeveralFiles={handleSubmitSeveralFiles}
                handleSubmit={handleSubmit}
                uploadMultiDocs={uploadMultiDocs}
                uploadTempDoc={uploadTempDoc}
                deleteDoc={deleteDoc}
                tempDoc={tempDoc}
                tempDocs={tempDocs}
                dataDoc={dataDoc}
                dataDocs={dataDocs}
                severalImgs={severalImgs}
                fileInput={fileInput}
                deleteDocs={deleteDocs}
                errorLimit={errorLimit}
                chatLoading={chatLoading}
                loading={loading || loadingTextProcessor}
                error={error}
              />
            }
          </>
        }
      </div>
    </S.ChatbotImgReaderCase>
  );

}

export default ChatbotImgReaderCase;
